// from Webamp demo

const album = 'netBloc Vol. 24: tiuqottigeloot';
import daydream from 'assets/sounds/music/ Daydream In Blue.mp3';
import dance from 'assets/sounds/music/dance.mp3';
import iloveu from 'assets/sounds/music/iloveu.mp3';
import mrrobot from 'assets/sounds/music/mrrobot.mp3';
import vessel from 'assets/sounds/music/Vessel.mp3';
import world from 'assets/sounds/music/world.mp3';


export const initialTracks = [
  {
    url:daydream,
    duration: 322.612245,
    metaData: {
      title: 'Daydream In Blue',
      artist: 'I monster',
      album,
    },
  },
  {
    url:
      mrrobot,
    duration: 147.331429,
    metaData: {
      title: 'Mr Robot',
      artist: '-',
      album,
    },
  },


  {
    url:
      vessel,
    duration: 400.331429,
    metaData: {
      title: 'vessel',
      artist: '-',
      album,
    },
  },



  {
    url:
      world,
    duration: 299.331429,
    metaData: {
      title: 'World',
      artist: '-',
      album,
    },
  },
  {
    url:
      dance,
    duration: 314.331429,
    metaData: {
      title: 'Dance',
      artist: '-',
      album,
    },
  },
  {
    url:
      iloveu,
    duration: 342.331429,
    metaData: {
      title: 'iloveu',
      artist: '-',
      album,
    },
  },



  {
    url:
      'https://raw.githubusercontent.com/captbaritone/webamp-music/4b556fbf/Nobara_Hayakawa_-_09_-_Trail.mp3',
    duration: 204.042449,
    metaData: {
      title: 'Trail',
      artist: 'Nobara Hayakawa',
      album,
    },
  },
  {
    url:
      'https://raw.githubusercontent.com/captbaritone/webamp-music/4b556fbf/Paper_Navy_-_10_-_Tongue_Tied.mp3',
    duration: 201.116735,
    metaData: {
      title: 'Tongue Tied',
      artist: 'Paper Navy',
      album,
    },
  },
  {
    url:
      'https://raw.githubusercontent.com/captbaritone/webamp-music/4b556fbf/60_Tigres_-_11_-_Garage.mp3',
    duration: 245.394286,
    metaData: {
      title: 'Garage',
      artist: '60 Tigres',
      album,
    },
  },
  {
    url:
      'https://raw.githubusercontent.com/captbaritone/webamp-music/4b556fbf/CM_aka_Creative_-_12_-_The_Cycle_Featuring_Mista_Mista.mp3',
    duration: 221.44,
    metaData: {
      title: 'The Cycle (Featuring Mista Mista)',
      artist: 'CM aka Creative',
      album,
    },
  },
  {
    url:
      'https://raw.githubusercontent.com/captbaritone/webamp-music/4b556fbf/Eclectek_-_02_-_We_Are_Going_To_Eclecfunk_Your_Ass.mp3',
    duration: 190.093061,
    metaData: {
      title: 'We Are Going To Eclecfunk Your Ass',
      artist: 'Eclectek',
      album,
    },
  },
  {
    url:
      'https://raw.githubusercontent.com/captbaritone/webamp-music/4b556fbf/Auto-Pilot_-_03_-_Seventeen.mp3',
    duration: 214.622041,
    metaData: {
      title: 'Seventeen',
      artist: 'Auto-Pilot',
      album,
    },
  },
  {
    url:
      'https://raw.githubusercontent.com/captbaritone/webamp-music/4b556fbf/Muha_-_04_-_Microphone.mp3',
    duration: 181.838367,
    metaData: {
      title: 'Microphone',
      artist: 'Muha',
      album,
    },
  },
  {
    url:
      'https://raw.githubusercontent.com/captbaritone/webamp-music/4b556fbf/Just_Plain_Ant_-_05_-_Stumble.mp3',
    duration: 86.047347,
    metaData: {
      title: 'Stumble',
      artist: 'Just Plain Ant',
      album,
    },
  },
  {
    url:
      'https://raw.githubusercontent.com/captbaritone/webamp-music/4b556fbf/Sleaze_-_06_-_God_Damn.mp3',
    duration: 226.795102,
    metaData: {
      title: 'God Damn',
      artist: 'Sleaze',
      album,
    },
  },
  {
    url:
      'https://raw.githubusercontent.com/captbaritone/webamp-music/4b556fbf/Juanitos_-_07_-_Hola_Hola_Bossa_Nova.mp3',
    duration: 207.072653,
    metaData: {
      title: 'Hola Hola Bossa Nova',
      artist: 'Juanitos',
      album,
    },
  },
];
